import { useQuery } from "@tanstack/react-query";
import { getClientJobs, type ClientJob } from "../actions/getClientJobs";

interface Params {
  clientUid: string;
  enabled?: boolean;
}

export function useClientJobsWithUnpaidEvents({ clientUid, enabled = true }: Params) {
  return useQuery<ClientJob[]>({
    queryKey: ["client-jobs-unpaid", clientUid],
    queryFn: async () => {
      const res = await getClientJobs({ clientUid });
      return res.items;
    },
    enabled: enabled && Boolean(clientUid),
    staleTime: 1000 * 30,
  });
}
